import DebugLayout from "components/navigation/DebugLayout";
import PageSpinner from "components/Spinners/PageSpinner";
import Login from "pages/login/Login";
import { lazy, type ReactElement, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

// Login stays eager — it's the first screen an unauthenticated user hits.
const ForgottenPasswordPage = lazy(
  () => import("pages/profile/ForgottenPasswordPage"),
);

const AuthRoutes = (): ReactElement => {
  return (
    <Suspense fallback={<PageSpinner spin>{null}</PageSpinner>}>
      <Routes>
        <Route element={<DebugLayout />}>
          <Route path={"/login"} element={<Login />} />
          <Route path={"/reset-password"} element={<ForgottenPasswordPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default AuthRoutes;
